module.exports = __webpack_public_path__ + "img/omg1.2ba0e062.png";